
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2xpE0", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $1efdfe59c5e09a1a$export$6d1402fb58384e4f);
/* eslint-disable react/no-danger */ /* eslint-disable react/no-children-prop */ 
var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $lhCUr = parcelRequire("lhCUr");

var $ipPpS = parcelRequire("ipPpS");

var $g90Ph = parcelRequire("g90Ph");
var $hMSe7 = parcelRequire("hMSe7");
var $8hj5W = parcelRequire("8hj5W");
var $iuHMI = parcelRequire("iuHMI");
var $je0s0 = parcelRequire("je0s0");
var $laDNV = parcelRequire("laDNV");

var $6cnUO = parcelRequire("6cnUO");

var $inPa6 = parcelRequire("inPa6");

var $hnvzE = parcelRequire("hnvzE");

var $58PBI = parcelRequire("58PBI");

var $dIouf = parcelRequire("dIouf");

var $kVysQ = parcelRequire("kVysQ");
var $6CEg5 = parcelRequire("6CEg5");

var $i5Ioa = parcelRequire("i5Ioa");

var $7xVCs = parcelRequire("7xVCs");

var $1w55j = parcelRequire("1w55j");

var $l4CMG = parcelRequire("l4CMG");

var $5XPyz = parcelRequire("5XPyz");

var $3PXtn = parcelRequire("3PXtn");

var $3hLsK = parcelRequire("3hLsK");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $52id1 = parcelRequire("52id1");
var $6zNhq = parcelRequire("6zNhq");

var $azYNm = parcelRequire("azYNm");

var $1NBp8 = parcelRequire("1NBp8");

var $7zgzO = parcelRequire("7zgzO");

var $hZpML = parcelRequire("hZpML");

var $de2j9 = parcelRequire("de2j9");

var $1C7kY = parcelRequire("1C7kY");

var $iCTcO = parcelRequire("iCTcO");

var $9wGTI = parcelRequire("9wGTI");

var $gsf3i = parcelRequire("gsf3i");

var $cJWhP = parcelRequire("cJWhP");

var $eJTjU = parcelRequire("eJTjU");

var $kmLIp = parcelRequire("kmLIp");

var $lPNJr = parcelRequire("lPNJr");

var $hayzU = parcelRequire("hayzU");

var $1qDZ3 = parcelRequire("1qDZ3");

var $i6tGf = parcelRequire("i6tGf");

var $JUk5P = parcelRequire("JUk5P");
const $1efdfe59c5e09a1a$var$resize = ()=>{
    window.dispatchEvent(new Event('resize'));
};
const $1efdfe59c5e09a1a$var$isRoute = (pathname, route)=>Boolean(route.match(pathname || ''));
const $1efdfe59c5e09a1a$var$routesToShowPageLayoutBreadcrumbNav = [
    (0, $1NBp8.SPACE_ANALYTICS),
    (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST),
    (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE),
    (0, $1NBp8.SPACE_PAGES),
    (0, $1NBp8.SPACE_CALENDARS),
    (0, $1NBp8.DATABASE_CUSTOM_OVERVIEW),
    (0, $1NBp8.SPACE_QUESTIONS)
];
const $1efdfe59c5e09a1a$var$TOP_NAV_HEIGHT = 56;
const $1efdfe59c5e09a1a$export$6d1402fb58384e4f = /*#__PURE__*/ (0, $gwFzn.memo)(({ children: children, view: view, standalone: standalone, isSpaceSettingsScreen: isSpaceSettingsScreen, editorPreloader: editorPreloader })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE,
        attributes: {
            errorBoundaryId: 'PageLayout-outer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1efdfe59c5e09a1a$var$PageLayoutInner, {
        children: children,
        view: view,
        standalone: standalone,
        isSpaceSettingsScreen: isSpaceSettingsScreen,
        editorPreloader: editorPreloader
    }));
});
const $1efdfe59c5e09a1a$var$PageLayoutInner = ({ children: children, view: view, standalone: standalone, isSpaceSettingsScreen: isSpaceSettingsScreen, editorPreloader: editorPreloader })=>{
    const [isInProductHelpOn, setIsInProductHelpOn] = (0, $gwFzn.useState)(false);
    const toggleInProductHelp = (val)=>{
        setIsInProductHelpOn(val);
    };
    const { scrollTree: scrollTree, pageTreeUpdater: pageTreeUpdater } = (0, $eJTjU.useScrollTree)({
        view: view
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const fireSidebarToggleAnalytics = (0, $gwFzn.useCallback)((action)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: 'spaceNavigation',
                source: 'containerNavigation',
                attributes: {
                    isOnEditRoute: isOnEditRoute
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isOnEditRoute
    ]);
    const onExpand = (0, $gwFzn.useCallback)(()=>{
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, 'expanded');
        scrollTree();
        $1efdfe59c5e09a1a$var$resize();
        fireSidebarToggleAnalytics('expanded');
    }, [
        scrollTree,
        fireSidebarToggleAnalytics
    ]);
    const onCollapse = (0, $gwFzn.useCallback)(()=>{
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, 'collapsed');
        $1efdfe59c5e09a1a$var$resize();
        fireSidebarToggleAnalytics('collapsed');
    }, [
        fireSidebarToggleAnalytics
    ]);
    const { isLoading: isLoading, isError: isError, isPanelOpen: isPanelOpen, isDismissed: isDismissed, openComponentId: openComponentId } = (0, $6zNhq.useQuickstartState)();
    const { isQuickstartEligible: isQuickstartEligible } = (0, $52id1.useQuickstartEligible)();
    const jswSpotlightOpen = openComponentId === (0, $3hLsK.SHOW_SWITCHER_SPOTLIGHT_ONLY) || openComponentId === (0, $3hLsK.JSW_XFLOW_SWITCHER_TOUR_TASK);
    // By default, the blanket should not be tinted, only tinted if onboarding jsw switcher spotlights are active
    const spotlightTriggeredByJswQS = isPanelOpen && !isDismissed && jswSpotlightOpen;
    const isQuickStartOpen = isPanelOpen && !isDismissed && !isLoading && !isError && isQuickstartEligible();
    const intl = (0, $dBxQj.default)();
    const { location: location } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    // show breadcrumb nav for routes listed in routesToShowPageLayoutBreadcrumbNav
    const showBreadcrumbNavHeader = $1efdfe59c5e09a1a$var$routesToShowPageLayoutBreadcrumbNav.some((route)=>$1efdfe59c5e09a1a$var$isRoute(location?.pathname, route));
    const SideNavSkiplinkText = intl.formatMessage((0, $kmLIp.i18n).SideNav);
    const EditContentButtonPreloaderContextValue = (0, $gwFzn.useMemo)(()=>editorPreloader || (()=>{}), [
        editorPreloader
    ]);
    const [{ isSpaceGettingStartedTourInProgress: isSpaceGettingStartedTourInProgress }] = (0, $l4CMG.useSpaceGettingStartedTour)();
    const isRedactionsTourActive = (0, $gsf3i.useRedactionsTourIsActive)();
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const standaloneGlobalStyles = (bannerHeight)=>standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lhCUr.Global), {
            "data-testid": "global-styles-SSR",
            styles: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.StyleFixSSRContentForNewLayoutWithRightSidebar)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                bannerHeight + $1efdfe59c5e09a1a$var$TOP_NAV_HEIGHT),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleCodeBlockFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.fontFamilyCLSFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleNoPrintNav),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.moreActionDropdownCLSFix)
            ]
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lhCUr.Global), {
            "data-testid": "global-styles",
            styles: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleCodeBlockFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.fontFamilyCLSFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleNoPrintNav),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.moreActionDropdownCLSFix)
            ]
        });
    const standaloneGlobalStylesCompiled = (bannerHeight)=>standalone ? /*
   * We're injecting global styles to handle styling targets that are not part of the React app, but are children of the HTML body
   * Previously, this used to be a `<Global styles={[…]} />` from Emotion
   * But in the Compiled migration, there is no alternative and feels like the best path forward for now.
   */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: (0, $lPNJr.fixSSRContentForNewLayoutWithRightSidebarStyles)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
            ...nonceValue !== undefined ? {
                nonce: nonceValue
            } : {},
            type: "text/css",
            dangerouslySetInnerHTML: {
                __html: (0, $lPNJr.globalStylesCompiled)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", null, `[${(0, $lPNJr.SSR_LAYOUT_DATA_ATTR)}], [${(0, $lPNJr.SSR_IFRAME_ATTR)}] {
					top: ${bannerHeight + $1efdfe59c5e09a1a$var$TOP_NAV_HEIGHT + 2}px !important;
				}`)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
            ...nonceValue !== undefined ? {
                nonce: nonceValue
            } : {},
            type: "text/css",
            dangerouslySetInnerHTML: {
                __html: (0, $lPNJr.globalStylesCompiled)
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE,
        attributes: {
            errorBoundaryId: 'PageLayoutInner'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cJWhP.NavigationExperienceWrapper), {
        view: view,
        navVersion: "3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
        subjectId: "NavigationLoading"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $58PBI.EditContentButtonPreloaderContext).Provider, {
        value: EditContentButtonPreloaderContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const bannerHeight = bannerState.getTotalHeight(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), {
            blanketIsTinted: isSpaceGettingStartedTourInProgress || spotlightTriggeredByJswQS || isRedactionsTourActive
        }, (0, $9wGTI.fg)('confluence_frontend_page_layout_compiled') ? standaloneGlobalStylesCompiled(bannerHeight) : standaloneGlobalStyles(bannerHeight), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qDZ3.PageLayoutContextProviderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iuHMI.default), {
            onLeftSidebarExpand: onExpand,
            onLeftSidebarCollapse: onCollapse,
            skipLinksLabel: intl.formatMessage((0, $kmLIp.i18n).SkipLinks)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lPNJr.ZIndexWrapper), {
            zIndex: 14,
            showQuickStart: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g90Ph.default), {
            height: bannerHeight,
            isFixed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5XPyz.BannerContainer), null)), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_TOP_NAV}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
            name: "top-nav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $laDNV.default), {
            testId: "grid-topNav",
            skipLinkTitle: intl.formatMessage((0, $kmLIp.i18n).TopNav),
            id: "AkTopNav",
            height: $1efdfe59c5e09a1a$var$TOP_NAV_HEIGHT,
            isFixed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1w55j.AppNavigationBase), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hayzU.LazyImpersonationFlag), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i5Ioa.ProgressBar), {
            isNav4: false
        }))), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_TOP_NAV}.end`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hMSe7.default), null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SIDE_NAV}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
            name: "side-nav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $JUk5P.SideNavigationSwitcher), {
            view: view,
            skiplinkText: SideNavSkiplinkText,
            isSpaceSettingsScreen: isSpaceSettingsScreen
        })), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SIDE_NAV}.end`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lPNJr.LayoutMainWrapper), {
            id: "layout-main-wrapper",
            showBreadcrumbNavHeader: showBreadcrumbNavHeader
        }, showBreadcrumbNavHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $azYNm.FixedBreadcrumbsNavForPageLayoutLoader), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_MAIN}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8hj5W.default), {
            testId: "grid-main-container",
            id: "AkMainContent",
            skipLinkTitle: intl.formatMessage((0, $kmLIp.i18n).Main)
        }, children && !standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            attribution: (0, $dIouf.Attribution).DISCO
        }, children) : null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_MAIN}.end`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i6tGf.RightSidebarLoader), {
            toggleInProductHelp: toggleInProductHelp
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lPNJr.ZIndexWrapper), {
            zIndex: 10,
            showQuickStart: isQuickStartOpen && !isInProductHelpOn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $je0s0.default), {
            width: isQuickStartOpen ? 368 : 0,
            isFixed: isQuickStartOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lPNJr.ContentRightSidePanel), {
            id: "content-right-side-panel"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdatesContainer)=>{
            pageTreeUpdater.current = pageTreeStateUpdatesContainer;
            return null;
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iCTcO.PreviewPanelContainer), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1C7kY.GlobalComponentsLoader), null)));
    }))));
};

});
parcelRegister("g90Ph", function(module, exports) {

$parcel$export(module.exports, "default", () => $80fc6dd3168dbcc6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $fS0n4 = parcelRequire("fS0n4");
var $1HIA2 = parcelRequire("1HIA2");

var $3xCvY = parcelRequire("3xCvY");

var $gXiBW = parcelRequire("gXiBW");
const $80fc6dd3168dbcc6$var$bannerStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $i72d6.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $i72d6.BANNER)
});
const $80fc6dd3168dbcc6$var$bannerFixedStyles = (0, $3jLHL.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $i72d6.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $i72d6.LEFT_PANEL_WIDTH)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $80fc6dd3168dbcc6$var$Banner = (props)=>{
    const { children: children, height: height = (0, $i72d6.DEFAULT_BANNER_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $nP1jF.resolveDimension)((0, $i72d6.VAR_BANNER_HEIGHT), height, shouldPersistHeight);
    (0, $gwFzn.useEffect)(()=>{
        (0, $fS0n4.default)({
            [(0, $i72d6.VAR_BANNER_HEIGHT)]: bannerHeight
        });
        return ()=>{
            (0, $fS0n4.default)({
                [(0, $i72d6.VAR_BANNER_HEIGHT)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $1HIA2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3xCvY.default), null, ({ className: className })=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: [
                $80fc6dd3168dbcc6$var$bannerStyles,
                isFixed && $80fc6dd3168dbcc6$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $nP1jF.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gXiBW.default), {
            variableName: (0, $i72d6.VAR_BANNER_HEIGHT),
            value: bannerHeight
        }), children));
};
var $80fc6dd3168dbcc6$export$2e2bcd8739ae039 = $80fc6dd3168dbcc6$var$Banner;

});

parcelRegister("hMSe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d5b5ecb1bfdf82a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $i72d6 = parcelRequire("i72d6");
const $0d5b5ecb1bfdf82a$var$contentStyles = (0, $3jLHL.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $i72d6.CONTENT)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $0d5b5ecb1bfdf82a$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        "data-testid": testId,
        css: $0d5b5ecb1bfdf82a$var$contentStyles
    }, children);
};
var $0d5b5ecb1bfdf82a$export$2e2bcd8739ae039 = $0d5b5ecb1bfdf82a$var$Content;

});

parcelRegister("8hj5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c22fb3f3aa926f73$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $7hpmn = parcelRequire("7hpmn");

var $ig6yX = parcelRequire("ig6yX");

var $i72d6 = parcelRequire("i72d6");

var $gL4SZ = parcelRequire("gL4SZ");

var $nP1jF = parcelRequire("nP1jF");

var $jZM59 = parcelRequire("jZM59");
var $1HIA2 = parcelRequire("1HIA2");

var $3xCvY = parcelRequire("3xCvY");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c22fb3f3aa926f73$var$prefersReducedMotionStyles = (0, $3jLHL.css)((0, $7hpmn.prefersReducedMotion)());
const $c22fb3f3aa926f73$var$mainStyles = (0, $3jLHL.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`
});
const $c22fb3f3aa926f73$var$draggingStyles = (0, $3jLHL.css)({
    // Make sure drag to resize remains snappy.
    transition: 'none'
});
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $c22fb3f3aa926f73$var$flyoutStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $i72d6.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $c22fb3f3aa926f73$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $1HIA2.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $gL4SZ.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $gwFzn.useContext)((0, $jZM59.SidebarResizeContext));
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3xCvY.default), null, ({ className: className })=>/*#__PURE__*/ (0, $3jLHL.jsx)("main", {
            "data-testid": testId,
            css: [
                $c22fb3f3aa926f73$var$mainStyles,
                isDragging && $c22fb3f3aa926f73$var$draggingStyles,
                isFlyoutOpen && !isFixed && $c22fb3f3aa926f73$var$flyoutStyles,
                $c22fb3f3aa926f73$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $nP1jF.getPageLayoutSlotSelector)('main')
        }, children));
};
var $c22fb3f3aa926f73$export$2e2bcd8739ae039 = $c22fb3f3aa926f73$var$Main;

});
parcelRegister("gL4SZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $79ba5697cb6a71da$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $i72d6 = parcelRequire("i72d6");
const $79ba5697cb6a71da$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $i72d6.IS_SIDEBAR_DRAGGING)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $79ba5697cb6a71da$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $gwFzn.useState)($79ba5697cb6a71da$var$getIsDragging);
    (0, $gwFzn.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($79ba5697cb6a71da$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $i72d6.IS_SIDEBAR_DRAGGING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $79ba5697cb6a71da$export$2e2bcd8739ae039 = $79ba5697cb6a71da$var$useIsSidebarDragging;

});


parcelRegister("iuHMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $72942e2c49dd78cd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $bWLcG = parcelRequire("bWLcG");

var $i72d6 = parcelRequire("i72d6");

var $gYbmQ = parcelRequire("gYbmQ");
var $8179W = parcelRequire("8179W");

var $zwOCD = parcelRequire("zwOCD");
const $72942e2c49dd78cd$var$pageLayoutSelector = {
    [(0, $i72d6.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
};
const $72942e2c49dd78cd$var$gridTemplateAreasMobile = `
${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.BANNER)}"
  ${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.TOP_NAVIGATION)}"
  ${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.CONTENT)}"
 `;
const $72942e2c49dd78cd$var$gridTemplateAreas = `
${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.BANNER)} ${(0, $i72d6.RIGHT_PANEL)}"
  ${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.TOP_NAVIGATION)} ${(0, $i72d6.RIGHT_PANEL)}"
${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.CONTENT)} ${(0, $i72d6.RIGHT_PANEL)}"
 `;
const $72942e2c49dd78cd$var$gridStyles = (0, $3jLHL.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $72942e2c49dd78cd$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $i72d6.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $i72d6.RIGHT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $i72d6.BANNER_HEIGHT)} ${(0, $i72d6.TOP_NAVIGATION_HEIGHT)} auto`,
    outline: 'none'
});
const $72942e2c49dd78cd$var$gridStylesMobileStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $72942e2c49dd78cd$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $i72d6.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $72942e2c49dd78cd$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $i72d6.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $8179W.SkipLinksController), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $zwOCD.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...$72942e2c49dd78cd$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $72942e2c49dd78cd$var$gridStyles,
            $72942e2c49dd78cd$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gYbmQ.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $72942e2c49dd78cd$export$2e2bcd8739ae039 = $72942e2c49dd78cd$var$PageLayout;

});
parcelRegister("gYbmQ", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $921ef14c0b0dd899$export$850bd1bba41f1448);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $ee7An = parcelRequire("ee7An");

var $7hpmn = parcelRequire("7hpmn");

var $fFc6D = parcelRequire("fFc6D");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $jZM59 = parcelRequire("jZM59");
const $921ef14c0b0dd899$var$handleDataAttributesAndCb = (callback = (0, $ee7An.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $i72d6.IS_SIDEBAR_COLLAPSING));
    callback(leftSidebarState);
};
const $921ef14c0b0dd899$var$leftSidebarSelector = (0, $nP1jF.getPageLayoutSlotCSSSelector)('left-sidebar');
const $921ef14c0b0dd899$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $gwFzn.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $gwFzn.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $gwFzn.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $gwFzn.useRef)(null);
    const mobileMediaQuery = (0, $fFc6D.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $gwFzn.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $921ef14c0b0dd899$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $921ef14c0b0dd899$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($921ef14c0b0dd899$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $7hpmn.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $d8F95.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $gwFzn.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $921ef14c0b0dd899$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $i72d6.IS_SIDEBAR_COLLAPSING), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $921ef14c0b0dd899$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($921ef14c0b0dd899$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $7hpmn.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $d8F95.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $gwFzn.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $gwFzn.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $gwFzn.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jZM59.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("8179W", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $f89eafe267ae0a24$export$da7be99d6a868f3d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $i72d6 = parcelRequire("i72d6");

var $1HIA2 = parcelRequire("1HIA2");
const $f89eafe267ae0a24$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $i72d6.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $f89eafe267ae0a24$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $gwFzn.useState)([]);
    const registerSkipLink = (0, $gwFzn.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($f89eafe267ae0a24$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $gwFzn.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1HIA2.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("zwOCD", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $736ed2e169d6421e$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $2Nwuj = parcelRequire("2Nwuj");

var $ig6yX = parcelRequire("ig6yX");
var $7hpmn = parcelRequire("7hpmn");

var $6fnsQ = parcelRequire("6fnsQ");

var $i72d6 = parcelRequire("i72d6");

var $1HIA2 = parcelRequire("1HIA2");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $736ed2e169d6421e$var$prefersReducedMotionStyles = (0, $3jLHL.css)((0, $7hpmn.prefersReducedMotion)());
const $736ed2e169d6421e$var$skipLinkStyles = (0, $3jLHL.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $6fnsQ.N30A)}, 0 2px 10px ${(0, $6fnsQ.N30A)}, 0 0 20px -4px ${(0, $6fnsQ.N60A)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $ig6yX.easeOut)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $736ed2e169d6421e$var$skipLinkHeadingStyles = (0, $3jLHL.css)({
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $736ed2e169d6421e$var$skipLinkListStyles = (0, $3jLHL.css)({
    listStylePosition: 'outside',
    listStyleType: 'none',
    marginBlockStart: "var(--ds-space-050, 4px)",
    paddingInlineStart: 0
});
const $736ed2e169d6421e$var$skipLinkListItemStyles = (0, $3jLHL.css)({
    marginBlockStart: 0
});
const $736ed2e169d6421e$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $736ed2e169d6421e$var$assignIndex(num + 1, arr);
};
const $736ed2e169d6421e$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $1HIA2.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $736ed2e169d6421e$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $i72d6.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $i72d6.DEFAULT_I18N_PROPS_SKIP_LINKS);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $736ed2e169d6421e$var$skipLinkStyles,
            $736ed2e169d6421e$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $3jLHL.jsx)("p", {
        css: $736ed2e169d6421e$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $3jLHL.jsx)("ol", {
        css: $736ed2e169d6421e$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $3jLHL.jsx)($736ed2e169d6421e$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle)))));
};
const $736ed2e169d6421e$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $736ed2e169d6421e$var$handleBlur);
};
const $736ed2e169d6421e$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $736ed2e169d6421e$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $736ed2e169d6421e$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("li", {
        css: $736ed2e169d6421e$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Nwuj.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $736ed2e169d6421e$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("laDNV", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b537b6d819b3ce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $fS0n4 = parcelRequire("fS0n4");
var $1HIA2 = parcelRequire("1HIA2");

var $3xCvY = parcelRequire("3xCvY");

var $gXiBW = parcelRequire("gXiBW");
const $29b537b6d819b3ce$var$topNavigationStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $i72d6.TOP_NAVIGATION_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $i72d6.TOP_NAVIGATION)
});
const $29b537b6d819b3ce$var$fixedStyles = (0, $3jLHL.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $i72d6.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $i72d6.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $i72d6.LEFT_PANEL_WIDTH)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $29b537b6d819b3ce$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $i72d6.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $nP1jF.resolveDimension)((0, $i72d6.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
    (0, $gwFzn.useEffect)(()=>{
        (0, $fS0n4.default)({
            [(0, $i72d6.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
        });
        return ()=>{
            (0, $fS0n4.default)({
                [(0, $i72d6.VAR_TOP_NAVIGATION_HEIGHT)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $1HIA2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3xCvY.default), null, ({ className: className })=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: [
                $29b537b6d819b3ce$var$topNavigationStyles,
                isFixed && $29b537b6d819b3ce$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $nP1jF.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gXiBW.default), {
            variableName: (0, $i72d6.VAR_TOP_NAVIGATION_HEIGHT),
            value: topNavigationHeight
        }), children));
};
var $29b537b6d819b3ce$export$2e2bcd8739ae039 = $29b537b6d819b3ce$var$TopNavigation;

});

parcelRegister("i6tGf", function(module, exports) {

$parcel$export(module.exports, "RightSidebarLoader", () => $3aa2dee10c94a2bd$export$a93b70acade45e11);

var $jmjWc = parcelRequire("jmjWc");

const $3aa2dee10c94a2bd$export$a93b70acade45e11 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Q11vO",
    name: "RightSidebarLoader",
    loader: async ()=>(await (parcelRequire("6biRd"))).RightSidebar
});

});
parcelRegister("6biRd", function(module, exports) {

let $480265d9cbd76d1e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $480265d9cbd76d1e$var$load("jqXtk"),
    $480265d9cbd76d1e$var$load("02UZz"),
    $480265d9cbd76d1e$var$load("7VJag"),
    $480265d9cbd76d1e$var$load("9gORV"),
    $480265d9cbd76d1e$var$load("dijb5"),
    $480265d9cbd76d1e$var$load("g1nDL"),
    $480265d9cbd76d1e$var$load("66oaK"),
    $480265d9cbd76d1e$var$load("4jltO"),
    $480265d9cbd76d1e$var$load("aoOM9"),
    $480265d9cbd76d1e$var$load("a9OJ4"),
    $480265d9cbd76d1e$var$load("kGIBm"),
    $480265d9cbd76d1e$var$load("69J1q"),
    $480265d9cbd76d1e$var$load("6TXNV"),
    $480265d9cbd76d1e$var$load("8tqgK"),
    $480265d9cbd76d1e$var$load("cyGuT"),
    $480265d9cbd76d1e$var$load("kjZZD"),
    $480265d9cbd76d1e$var$load("aGZFn"),
    $480265d9cbd76d1e$var$load("c6MKV"),
    $480265d9cbd76d1e$var$load("feuOx"),
    $480265d9cbd76d1e$var$load("aZinD"),
    $480265d9cbd76d1e$var$load("8gT5h"),
    $480265d9cbd76d1e$var$load("6qah4"),
    $480265d9cbd76d1e$var$load("ffEVr"),
    $480265d9cbd76d1e$var$load("joJy8"),
    $480265d9cbd76d1e$var$load("aHE9G"),
    $480265d9cbd76d1e$var$load("jmmCO")
]).then(()=>parcelRequire('8tIfI'));

});


parcelRegister("JUk5P", function(module, exports) {

$parcel$export(module.exports, "SideNavigationSwitcher", () => $0d29c9a739c95b01$export$bcb01672fa577c2f);
/* SideNavigationSwitcher.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $3gadb = parcelRequire("3gadb");

var $cnSYc = parcelRequire("cnSYc");
var $jZM59 = parcelRequire("jZM59");

var $6zNhq = parcelRequire("6zNhq");

var $ljm2R = parcelRequire("ljm2R");

var $7uIhU = parcelRequire("7uIhU");

var $7zgzO = parcelRequire("7zgzO");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $bbp3G = parcelRequire("bbp3G");

var $hQnHK = parcelRequire("hQnHK");

var $de2j9 = parcelRequire("de2j9");

var $cEgMD = parcelRequire("cEgMD");

var $ep3mz = parcelRequire("ep3mz");

var $efvKr = parcelRequire("efvKr");

var $8zMP3 = parcelRequire("8zMP3");

var $2esS1 = parcelRequire("2esS1");
const $0d29c9a739c95b01$var$i18n = (0, $2nPZH.defineMessages)({
    collapseLabel: {
        id: "page-layout.sidebar.collapse.label",
        defaultMessage: "Collapse sidebar"
    },
    expandLabel: {
        id: "page-layout.sidebar.expand.label",
        defaultMessage: "Expand sidebar"
    },
    collapseTooltip: {
        id: "page-layout.sidebar.tooltip.collapse",
        defaultMessage: "Collapse"
    },
    expandTooltip: {
        id: "page-layout.sidebar.tooltip.expand",
        defaultMessage: "Expand"
    }
});
const $0d29c9a739c95b01$var$DEFAULT_SIDEBAR_WIDTH = 240;
const $0d29c9a739c95b01$var$ExpandKeyboardShortcut = ()=>{
    const [readyForToggle, setReadyForToggle] = (0, $gwFzn.useState)(true);
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed, expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $jZM59.usePageLayoutResize)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const toggleSidebarCollapse = (0, $gwFzn.useCallback)(()=>{
        if (readyForToggle) {
            if (isLeftSidebarCollapsed) expandLeftSidebar();
            else collapseLeftSidebar();
            setReadyForToggle(false);
            setTimeout(()=>setReadyForToggle(true), 350);
        }
    }, [
        isLeftSidebarCollapsed,
        expandLeftSidebar,
        collapseLeftSidebar,
        readyForToggle
    ]);
    const toggle = (0, $gwFzn.useCallback)(()=>{
        if (!(0, $bbp3G.isDialogShown)()) {
            toggleSidebarCollapse();
            setReadyForToggle(false);
            setTimeout(()=>setReadyForToggle(true), 350);
        }
    }, [
        toggleSidebarCollapse
    ]);
    return isLiveEditMode || isOnEditRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutListener), {
        accelerator: (0, $ljm2R.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
        listener: toggle
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: [
            (0, $ljm2R.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            (0, $ljm2R.SIDE_NAVIGATION_SHORTCUT)
        ],
        listener: toggle
    });
};
//SidebarWrapper is a SUPER common Component name in AK
const $0d29c9a739c95b01$var$confSidebarWrapperStyles = null;
const $0d29c9a739c95b01$var$useSideNavState = ()=>{
    const { isPanelOpen: isPanelOpen, isDismissed: isDismissed } = (0, $6zNhq.useQuickstartState)();
    const shouldForceExpand = isPanelOpen && !isDismissed;
    const persistedCollapseState = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) ?? 'expanded';
    const persistedWidth = parseInt((0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH //can return null
    ) || $0d29c9a739c95b01$var$DEFAULT_SIDEBAR_WIDTH, 10);
    const initialCollapsedState = shouldForceExpand ? 'expanded' : persistedCollapseState;
    const fittedSidebarWidth = persistedWidth > window.innerWidth ? $0d29c9a739c95b01$var$DEFAULT_SIDEBAR_WIDTH : persistedWidth;
    return {
        initialCollapsedState: initialCollapsedState,
        initialWidth: fittedSidebarWidth,
        shouldForceExpand: shouldForceExpand
    };
};
const $0d29c9a739c95b01$var$useSideNavEnabled = (view)=>{
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return match?.query?.mode !== 'global' && view && [
        (0, $2esS1.CONTAINER_HOME_ID),
        (0, $2esS1.CONTAINER_BLOG_ID),
        (0, $2esS1.CONTAINER_HOME_LOADING_ID),
        (0, $2esS1.ADMIN_HOME_ID)
    ].includes(view) && // The side nav is not desirable in Company Hub, because it hides its space from the user.
    // But only CONTAINER_XXX represent space-related side navs, ADMIN_HOME_ID is for site-related admin side nav.
    (!(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || view === (0, $2esS1.ADMIN_HOME_ID));
};
const $0d29c9a739c95b01$var$useSideNavResize = (shouldForceExpand)=>{
    const { expandLeftSidebar: expandLeftSidebar } = (0, $jZM59.usePageLayoutResize)(); // CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
    // Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
    const onResizeStart = (0, $gwFzn.useCallback)(()=>{
        document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.setProperty('pointer-events', 'none');
    }, []);
    const onResizeEnd = (0, $gwFzn.useCallback)((leftSidebarState)=>{
        // CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
        // Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
        document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.removeProperty('pointer-events');
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH, leftSidebarState.leftSidebarWidth);
        if (shouldForceExpand && !leftSidebarState.leftSidebarWidth) expandLeftSidebar();
    }, [
        shouldForceExpand,
        expandLeftSidebar
    ]);
    return {
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    };
};
const $0d29c9a739c95b01$var$getSideNavigation = (view, isSpaceSettingsScreen)=>{
    switch(view){
        case 0, $2esS1.CONTAINER_HOME_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.SpaceNavigation), {
                isSpaceSettingsScreen: isSpaceSettingsScreen
            });
        case 0, $2esS1.CONTAINER_BLOG_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.SpaceNavigation), {
                isBlogNavigation: true,
                isSpaceSettingsScreen: false
            });
        case 0, $2esS1.CONTAINER_HOME_LOADING_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.SpaceNavigationLoadingSkeleton), null);
        case 0, $2esS1.ADMIN_HOME_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.AdminNavigationLoader), null);
    }
    return null;
};
const $0d29c9a739c95b01$export$bcb01672fa577c2f = ({ view: view, skiplinkText: skiplinkText, isSpaceSettingsScreen: isSpaceSettingsScreen = false })=>{
    const isSideNavEnabled = $0d29c9a739c95b01$var$useSideNavEnabled(view);
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth, shouldForceExpand: shouldForceExpand } = $0d29c9a739c95b01$var$useSideNavState();
    const { onResizeStart: onResizeStart, onResizeEnd: onResizeEnd } = $0d29c9a739c95b01$var$useSideNavResize(shouldForceExpand);
    const sideNavigation = $0d29c9a739c95b01$var$getSideNavigation(view, isSpaceSettingsScreen);
    const intl = (0, $dBxQj.default)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const getTooltipTextI18n = (isLeftSidebarCollapsed)=>isLeftSidebarCollapsed ? $0d29c9a739c95b01$var$i18n.expandTooltip : $0d29c9a739c95b01$var$i18n.collapseTooltip;
    const getExpanderButtonLabelI18n = (isLeftSidebarCollapsed)=>isLeftSidebarCollapsed ? $0d29c9a739c95b01$var$i18n.expandLabel : $0d29c9a739c95b01$var$i18n.collapseLabel;
    return isSideNavEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_11q711bn _1pbyilow _kf1jmuej _xlsvt94y _1pevt94y _1brykb7n _jj8pidpf _e1qhidpf _11mwf6fq _smi9go27 _qd9hvuon"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cnSYc.default), {
        testId: "grid-left-sidebar",
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        width: initialWidth,
        collapsedState: initialCollapsedState,
        skipLinkTitle: skiplinkText,
        id: "AkSideNavigation",
        overrides: {
            ResizeButton: {
                render: (Component, props)=>shouldForceExpand ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                            contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), getTooltipTextI18n(props.isLeftSidebarCollapsed)),
                            shortcut: (0, $ljm2R.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
                            isEditorShortcut: isOnEditRoute,
                            isTooltip: true
                        }),
                        hideTooltipOnClick: true,
                        position: "right",
                        testId: "sidebar-collapse-tooltip",
                        ignoreTooltipPointerEvents: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
                        "aria-label": intl.formatMessage(getExpanderButtonLabelI18n(props.isLeftSidebarCollapsed)),
                        ...props
                    }))
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "side-navigation"
    }, sideNavigation), !shouldForceExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0d29c9a739c95b01$var$ExpandKeyboardShortcut, null))) : null;
};

});
parcelRegister("cnSYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e84c623a4762216$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $cr6pC = parcelRequire("cr6pC");

var $ig6yX = parcelRequire("ig6yX");

var $fFc6D = parcelRequire("fFc6D");

var $6fnsQ = parcelRequire("6fnsQ");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $fS0n4 = parcelRequire("fS0n4");
var $jZM59 = parcelRequire("jZM59");
var $1HIA2 = parcelRequire("1HIA2");

var $eNyVi = parcelRequire("eNyVi");

var $kCXTI = parcelRequire("kCXTI");

var $c7KQg = parcelRequire("c7KQg");

var $bNGOo = parcelRequire("bNGOo");

var $gXiBW = parcelRequire("gXiBW");
const $3e84c623a4762216$var$openBackdropStyles = (0, $3jLHL.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $6fnsQ.N100A)})`,
    opacity: 1
});
const $3e84c623a4762216$var$hiddenBackdropStyles = (0, $3jLHL.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $3e84c623a4762216$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $gwFzn.useRef)();
    const mouseOverEventRef = (0, $gwFzn.useRef)();
    const leftSideBarRef = (0, $gwFzn.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $gwFzn.useContext)((0, $jZM59.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, hasInit: hasInit } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $gwFzn.useRef)(isLocked);
    const mouseXRef = (0, $gwFzn.useRef)(0);
    const handlerRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $nP1jF.resolveDimension)((0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH);
    else leftSidebarWidthOnMount = (0, $nP1jF.resolveDimension)((0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH), _width, !width || !collapsedStateOverrideOpen && (0, $nP1jF.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $gwFzn.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $nP1jF.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $nP1jF.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT], (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT], (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed,
            hasInit: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $fS0n4.default)({
                [(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT)]: lastLeftSidebarWidth
            });
            (0, $nP1jF.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $i72d6.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $i72d6.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $i72d6.FLYOUT_DELAY));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $1HIA2.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $i72d6.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $i72d6.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $i72d6.FLYOUT_DELAY));
    };
    const mobileMediaQuery = (0, $fFc6D.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $gwFzn.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $gwFzn.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $fFc6D.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $cr6pC.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    /**
   * We use both the state and our effect-based ref to protect animation until initialized fully
   */ const isReady = hasInit && notFirstRun.current;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            $3e84c623a4762216$var$hiddenBackdropStyles,
            isFlyoutOpen && $3e84c623a4762216$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $c7KQg.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gXiBW.default), {
        variableName: (0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH),
        value: isReady ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $i72d6.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)
    }), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $kCXTI.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bNGOo.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !isReady && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $eNyVi.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $3e84c623a4762216$export$2e2bcd8739ae039 = $3e84c623a4762216$var$LeftSidebar;

});
parcelRegister("eNyVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9398dc1f044e7907$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $d8F95 = parcelRequire("d8F95");

var $2ZsRZ = parcelRequire("2ZsRZ");

var $fFc6D = parcelRequire("fFc6D");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $jZM59 = parcelRequire("jZM59");

var $iTa1r = parcelRequire("iTa1r");

var $el48X = parcelRequire("el48X");

var $aMx71 = parcelRequire("aMx71");
const $9398dc1f044e7907$var$cssSelector = {
    [(0, $i72d6.RESIZE_CONTROL_SELECTOR)]: true
};
const $9398dc1f044e7907$var$resizeControlStyles = (0, $3jLHL.css)({
    position: 'absolute',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: '100%',
    outline: 'none'
});
const $9398dc1f044e7907$var$showResizeButtonStyles = (0, $3jLHL.css)({
    '--ds--resize-button--opacity': 1
});
// @ts-expect-error adding `!important` to style rules is currently a type error
const $9398dc1f044e7907$var$globalResizingStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '*': {
        // Setting the cursor to be `ew-resize` on all elements so that even if the user
        // pointer slips off the resize handle, the cursor will still be the resize cursor
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        cursor: 'ew-resize !important',
        // Blocking selection while resizing
        // Notes:
        // - This prevents a user selection being caused by resizing
        // - Safari + Firefox → all good
        // - Chrome → This will undo the current selection while resizing (not ideal)
        //   - The current selection will resume after resizing
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        userSelect: 'none !important'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    iframe: {
        // Disabling pointer events on iframes when resizing
        // as iframes will swallower user events when the user is over them
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        pointerEvents: 'none !important'
    }
});
const $9398dc1f044e7907$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $gwFzn.useContext)((0, $jZM59.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $gwFzn.useRef)(leftSidebarState[0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $gwFzn.useRef)(0);
    const keyboardEventTimeout = (0, $gwFzn.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $gwFzn.useState)(false);
    const unbindEvents = (0, $gwFzn.useRef)(null);
    const mobileMediaQuery = (0, $fFc6D.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $gwFzn.useRef)(leftSidebarState);
    (0, $gwFzn.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $gwFzn.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH] - (0, $nP1jF.getLeftPanelWidth)();
        unbindEvents.current = (0, $d8F95.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH));
                        document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $i72d6.IS_SIDEBAR_DRAGGING), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $i72d6.IS_SIDEBAR_DRAGGING));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $gwFzn.useState)(()=>(0, $2ZsRZ.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $nP1jF.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH));
            document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $i72d6.IS_SIDEBAR_DRAGGING));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $i72d6.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $i72d6.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD) && sidebarWidth.current < (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
            document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)]: (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $nP1jF.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                width = (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH);
                document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $gwFzn.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $gwFzn.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $3jLHL.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $gwFzn.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $nP1jF.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $nP1jF.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...$9398dc1f044e7907$var$cssSelector,
        css: [
            $9398dc1f044e7907$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $9398dc1f044e7907$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $aMx71.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $iTa1r.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $el48X.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3jLHL.Global), {
        styles: $9398dc1f044e7907$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9398dc1f044e7907$export$2e2bcd8739ae039 = $9398dc1f044e7907$var$ResizeControl;

});
parcelRegister("iTa1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $982ec4d5608019c5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $6fnsQ = parcelRequire("6fnsQ");

var $i72d6 = parcelRequire("i72d6");
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $982ec4d5608019c5$var$varLineColor = '--ds-line';
const $982ec4d5608019c5$var$grabAreaStyles = (0, $3jLHL.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$982ec4d5608019c5$var$varLineColor]: `var(--ds-border-selected, ${(0, $6fnsQ.B200)})`
    }
});
const $982ec4d5608019c5$var$grabAreaCollapsedStyles = (0, $3jLHL.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $982ec4d5608019c5$var$lineStyles = (0, $3jLHL.css)({
    display: 'block',
    width: "var(--ds-border-width-outline, 2px)",
    height: '100%',
    backgroundColor: 'var(--ds-line)',
    transition: 'background-color 200ms'
});
const $982ec4d5608019c5$var$grabAreaLineSelector = {
    [(0, $i72d6.GRAB_AREA_LINE_SELECTOR)]: true
};
const $982ec4d5608019c5$var$grabAreaSelector = {
    [(0, $i72d6.GRAB_AREA_SELECTOR)]: true
};
const $982ec4d5608019c5$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $3jLHL.jsx)("button", {
        ...$982ec4d5608019c5$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $982ec4d5608019c5$var$grabAreaStyles,
            isLeftSidebarCollapsed && $982ec4d5608019c5$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $982ec4d5608019c5$var$lineStyles,
        ...$982ec4d5608019c5$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$982ec4d5608019c5$export$2e2bcd8739ae039 = $982ec4d5608019c5$var$GrabArea;

});

parcelRegister("el48X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b3f426c3b7b32cb$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $15HFc = parcelRequire("15HFc");

var $ig6yX = parcelRequire("ig6yX");

var $4c48T = parcelRequire("4c48T");

var $bWLcG = parcelRequire("bWLcG");

var $6fnsQ = parcelRequire("6fnsQ");

var $i72d6 = parcelRequire("i72d6");
const $3b3f426c3b7b32cb$var$increaseHitAreaStyles = (0, $3jLHL.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $3b3f426c3b7b32cb$var$mobileStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $3b3f426c3b7b32cb$var$resizeIconButtonStyles = (0, $3jLHL.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $6fnsQ.N0)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    boxShadow: `0 0 0 1px ${(0, $6fnsQ.N30A)}, 0 2px 4px 1px ${(0, $6fnsQ.N30A)}`,
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N200)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $4c48T.durations).small}ms linear,
    color ${(0, $4c48T.durations).small}ms linear,
    opacity ${(0, $4c48T.durations).medium}ms ${(0, $ig6yX.easeOut)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $6fnsQ.B100)})`,
        color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $6fnsQ.B200)})`,
        color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
        opacity: 1
    }
});
const $3b3f426c3b7b32cb$var$resizeIconButtonExpandedStyles = (0, $3jLHL.css)({
    transform: 'rotate(180deg)',
    transformOrigin: 7
});
const $3b3f426c3b7b32cb$var$preventDefault = (event)=>event.preventDefault();
const $3b3f426c3b7b32cb$var$cssSelector = {
    [(0, $i72d6.RESIZE_BUTTON_SELECTOR)]: true
};
const $3b3f426c3b7b32cb$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $3jLHL.jsx)("button", {
        ...$3b3f426c3b7b32cb$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $3b3f426c3b7b32cb$var$resizeIconButtonStyles,
            $3b3f426c3b7b32cb$var$mobileStyles,
            !isLeftSidebarCollapsed && $3b3f426c3b7b32cb$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $3b3f426c3b7b32cb$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($15HFc))), {
        label: "",
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $3b3f426c3b7b32cb$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3b3f426c3b7b32cb$export$2e2bcd8739ae039 = $3b3f426c3b7b32cb$var$ResizeButton;

});

parcelRegister("aMx71", function(module, exports) {

$parcel$export(module.exports, "default", () => $a541337233c62c24$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $ig6yX = parcelRequire("ig6yX");

var $gL4SZ = parcelRequire("gL4SZ");
const $a541337233c62c24$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $a541337233c62c24$var$direction = 'to left';
const $a541337233c62c24$var$transitionDuration = '0.22s';
const $a541337233c62c24$var$shadowStyles = (0, $3jLHL.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$a541337233c62c24$var$direction}, ${$a541337233c62c24$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $a541337233c62c24$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $ig6yX.easeOut)
});
const $a541337233c62c24$var$draggingStyles = (0, $3jLHL.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$a541337233c62c24$var$direction}, ${$a541337233c62c24$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $a541337233c62c24$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $gL4SZ.default)();
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        "data-testid": testId,
        css: [
            $a541337233c62c24$var$shadowStyles,
            isDragging && $a541337233c62c24$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a541337233c62c24$export$2e2bcd8739ae039 = $a541337233c62c24$var$Shadow;

});


parcelRegister("kCXTI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44b071e79511136d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $ig6yX = parcelRequire("ig6yX");
var $7hpmn = parcelRequire("7hpmn");

var $bWLcG = parcelRequire("bWLcG");

var $i72d6 = parcelRequire("i72d6");

var $gL4SZ = parcelRequire("gL4SZ");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $44b071e79511136d$var$prefersReducedMotionStyles = (0, $3jLHL.css)((0, $7hpmn.prefersReducedMotion)());
const $44b071e79511136d$var$mobileStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $i72d6.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $i72d6.BANNER_HEIGHT)} + ${(0, $i72d6.TOP_NAVIGATION_HEIGHT)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $i72d6.LEFT_PANEL_WIDTH)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`
    }
});
const $44b071e79511136d$var$mobileInnerFlyoutStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $i72d6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $i72d6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s, box-shadow ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $44b071e79511136d$var$fixedInnerStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $i72d6.LEFT_SIDEBAR_WIDTH)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $i72d6.BANNER_HEIGHT)} + ${(0, $i72d6.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $i72d6.LEFT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`
});
const $44b071e79511136d$var$fixedInnerFlyoutStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $i72d6.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $44b071e79511136d$var$staticInnerStyles = (0, $3jLHL.css)({
    height: '100%'
});
const $44b071e79511136d$var$draggingStyles = (0, $3jLHL.css)({
    cursor: 'ew-resize',
    // Make sure drag to resize does not animate as the user drags
    transition: 'none'
});
const $44b071e79511136d$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $gL4SZ.default)();
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            // mobile viewport styles
            $44b071e79511136d$var$mobileStyles,
            isFlyoutOpen && $44b071e79511136d$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $44b071e79511136d$var$staticInnerStyles,
            isFixed && $44b071e79511136d$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $44b071e79511136d$var$fixedInnerFlyoutStyles,
            isDragging && $44b071e79511136d$var$draggingStyles,
            $44b071e79511136d$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$44b071e79511136d$export$2e2bcd8739ae039 = $44b071e79511136d$var$LeftSidebarInner;

});

parcelRegister("c7KQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9783221131ba50b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $ig6yX = parcelRequire("ig6yX");
var $7hpmn = parcelRequire("7hpmn");

var $bWLcG = parcelRequire("bWLcG");

var $i72d6 = parcelRequire("i72d6");

var $gL4SZ = parcelRequire("gL4SZ");

var $nP1jF = parcelRequire("nP1jF");

var $jZM59 = parcelRequire("jZM59");

var $3xCvY = parcelRequire("3xCvY");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $9783221131ba50b9$var$prefersReducedMotionStyles = (0, $3jLHL.css)((0, $7hpmn.prefersReducedMotion)());
const $9783221131ba50b9$var$mobileStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $i72d6.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $i72d6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            content: "''"
        }
    }
});
const $9783221131ba50b9$var$mobileFlyoutStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $9783221131ba50b9$var$outerStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $i72d6.LEFT_SIDEBAR_WIDTH),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $9783221131ba50b9$var$draggingStyles = (0, $3jLHL.css)({
    cursor: 'ew-resize',
    // Make sure drag to resize does not animate as the user drags
    transition: 'none'
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $9783221131ba50b9$var$fixedStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $i72d6.LEFT_SIDEBAR_WIDTH)}`,
        content: "''"
    }
});
const $9783221131ba50b9$var$flyoutStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $i72d6.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
const $9783221131ba50b9$var$flyoutFixedStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH)
});
const $9783221131ba50b9$var$selector = (0, $nP1jF.getPageLayoutSlotSelector)('left-sidebar');
const $9783221131ba50b9$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $gL4SZ.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $gwFzn.useContext)((0, $jZM59.SidebarResizeContext));
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3xCvY.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: [
                // mobile viewport styles
                $9783221131ba50b9$var$mobileStyles,
                isFlyoutOpen && $9783221131ba50b9$var$mobileFlyoutStyles,
                // generic styles
                $9783221131ba50b9$var$outerStyles,
                isFixed && $9783221131ba50b9$var$fixedStyles,
                isFlyoutOpen && $9783221131ba50b9$var$flyoutStyles,
                isFlyoutOpen && isFixed && $9783221131ba50b9$var$flyoutFixedStyles,
                isDragging && $9783221131ba50b9$var$draggingStyles,
                $9783221131ba50b9$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$9783221131ba50b9$var$selector
        }, children));
};
const $9783221131ba50b9$var$LeftSidebarOuter = /*#__PURE__*/ (0, $gwFzn.forwardRef)($9783221131ba50b9$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9783221131ba50b9$export$2e2bcd8739ae039 = $9783221131ba50b9$var$LeftSidebarOuter;

});

parcelRegister("bNGOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5caffb7635e842ca$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $7hpmn = parcelRequire("7hpmn");

var $i72d6 = parcelRequire("i72d6");

var $6eYLc = parcelRequire("6eYLc");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5caffb7635e842ca$var$prefersReducedMotionStyles = (0, $3jLHL.css)((0, $7hpmn.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $5caffb7635e842ca$var$hideLeftSidebarContentsStyles = (0, $3jLHL.css)({
    opacity: 0,
    transition: 'opacity 0ms linear, visibility 0ms linear',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $i72d6.TRANSITION_DURATION) - 100}ms`,
    visibility: 'hidden'
});
const $5caffb7635e842ca$var$resizableChildrenWrapperStyles = (0, $3jLHL.css)({
    height: '100%',
    opacity: 1,
    overflow: 'hidden auto',
    transition: 'none',
    visibility: 'visible'
});
const $5caffb7635e842ca$var$fixedChildrenWrapperStyles = (0, $3jLHL.css)({
    minWidth: 240,
    height: '100%'
});
const $5caffb7635e842ca$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $6eYLc.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            $5caffb7635e842ca$var$resizableChildrenWrapperStyles,
            isHidden && $5caffb7635e842ca$var$hideLeftSidebarContentsStyles,
            $5caffb7635e842ca$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId,
        tabIndex: isHidden ? -1 : 0
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $5caffb7635e842ca$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5caffb7635e842ca$export$2e2bcd8739ae039 = $5caffb7635e842ca$var$ResizableChildrenWrapper;

});
parcelRegister("6eYLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb92c2c5934a1475$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $i72d6 = parcelRequire("i72d6");
const $cb92c2c5934a1475$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $i72d6.IS_SIDEBAR_COLLAPSING)) === 'true';
};
const $cb92c2c5934a1475$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $gwFzn.useState)($cb92c2c5934a1475$var$getIsCollapsing);
    (0, $gwFzn.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($cb92c2c5934a1475$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $i72d6.IS_SIDEBAR_COLLAPSING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $cb92c2c5934a1475$export$2e2bcd8739ae039 = $cb92c2c5934a1475$var$useIsSidebarCollapsing;

});






//# sourceMappingURL=PageLayout.37a31138.js.map
